import page from "../../../sitePages/hovalin/docs";

export default page;
